import styled, { css } from 'styled-components';
import { whiteTheme } from 'modules/hairmakeup/styles/themes/whiteTheme';
import { Image } from 'ui/Image';

export const Wrap = styled.div`
  display: flex;
  width: 100%;
  height: 230px;
  position: relative;
  margin-bottom: 105px;
  background-color: #d7d7d7;
  p {
    width: 100%;
    margin-bottom: 0 !important;
  }
  && img {
    object-fit: cover;
  }
  ${whiteTheme.media.mobileS} {
    height: 170px;
  }
`;

export const Img = styled(Image).attrs(() => ({
  objectFit: 'fill',
}))`
  width: 100%;
  height: 100%;
  background-color: #d7d7d7;
`;
